import { r as registerInstance, h, g as getElement } from './index-d4808923.js';

const gravityBadgeGroupCss = ".badge-group{max-width:100%;overflow:hidden;position:relative}.badge-group__overflow-anchor{align-items:center;display:flex;height:100%;justify-content:center;margin-left:4px;user-select:none;width:20px}.badge-group__container{align-items:center;display:flex;gap:4px;height:var(--badge-group-height, 20px);overflow:hidden;padding-right:var(--badge-group-counter-spacer, 0);white-space:nowrap}.badge-group__container{flex-wrap:wrap}";
const GravityBadgeGroupStyle0 = gravityBadgeGroupCss;

const GravityBadgeGroup = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.possibleBadges = ['gravity-badge', 'gravity-category-badge', 'gravity-status-badge'];
        this.getAllBadges = () => {
            this.allBadges = this.element.querySelectorAll(this.possibleBadges.join(','));
            // if any of the badges has a size attribute set to large we need to adjust the height of the badge group container
            this.allBadges.forEach((badge) => {
                var _a;
                if (badge.getAttribute('size') === 'large') {
                    (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--badge-group-height', '24px');
                }
            });
        };
        this.checkWrappedBadges = () => {
            var _a, _b, _c;
            if (!((_a = this.allBadges) === null || _a === void 0 ? void 0 : _a.length))
                return;
            const THRESHOLD = 1;
            const allBadges = Array.from(this.allBadges);
            // We'll find the index of first badge that has wrapped to the next line
            const firstWrappedBadgeIndex = allBadges.findIndex((badge) => Math.abs(badge.offsetTop - this.allBadges[0].offsetTop) > THRESHOLD);
            if (firstWrappedBadgeIndex >= 0) {
                this.wrappedBadges = allBadges.slice(firstWrappedBadgeIndex);
                this.lastUnwrappedBadgeRect = allBadges[firstWrappedBadgeIndex - 1].getBoundingClientRect();
                (_b = this.containerRef) === null || _b === void 0 ? void 0 : _b.style.setProperty('--badge-group-counter-spacer', '20px');
            }
            else {
                this.wrappedBadges = [];
                (_c = this.containerRef) === null || _c === void 0 ? void 0 : _c.style.setProperty('--badge-group-counter-spacer', '0');
            }
        };
        this.handleSlotChange = () => {
            this.getAllBadges();
            this.checkWrappedBadges();
        };
        this.tooltip = true;
        this.tooltipMaxCount = 3;
        this.wrapAfterWidth = undefined;
        this.allBadges = undefined;
        this.lastUnwrappedBadgeRect = undefined;
        this.wrappedBadges = [];
    }
    renderCounterBadge() {
        if (this.wrappedBadges.length === 0)
            return null;
        const counterStyles = this.lastUnwrappedBadgeRect
            ? {
                position: 'absolute',
                left: `${this.lastUnwrappedBadgeRect.right - this.element.getBoundingClientRect().left}px`,
                top: `${this.lastUnwrappedBadgeRect.top - this.element.getBoundingClientRect().top}px`,
            }
            : {};
        return [
            h("div", { id: "overflow-anchor", class: "badge-group__overflow-anchor", style: counterStyles }, h("gravity-text", { size: "xx-small", weight: "medium", color: this.tooltip ? 'dark' : 'dark-subtle' }, "+", this.wrappedBadges.length)),
            this.renderTooltip(),
        ];
    }
    renderTooltip() {
        if (!this.tooltip || this.wrappedBadges.length === 0) {
            return null;
        }
        const getTooltipText = () => {
            const tooltipText = this.wrappedBadges.slice(0, this.tooltipMaxCount).map((badge) => { var _a; return (_a = badge.textContent) === null || _a === void 0 ? void 0 : _a.trim(); });
            if (tooltipText.length < this.wrappedBadges.length) {
                tooltipText.push('...');
            }
            return tooltipText.join(', ');
        };
        return (h("gravity-tooltip", { for: "overflow-anchor" }, h("gravity-text", { size: "xx-small", color: "light" }, getTooltipText())));
    }
    componentWillLoad() {
        this.getAllBadges();
    }
    componentDidLoad() {
        this.checkWrappedBadges();
        this.resizeObserver = new ResizeObserver(() => {
            this.checkWrappedBadges();
        });
        if (this.containerRef) {
            this.resizeObserver.observe(this.containerRef);
        }
    }
    disconnectedCallback() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    render() {
        return (h("div", { key: '394acb249db796ee42a9575d548fb5025a47f2ad', class: "badge-group", style: { width: `${this.wrapAfterWidth}px` } }, h("div", { key: '719551b34190bc29d41c9e3ed3a857f1d6411282', class: "badge-group__container", ref: (el) => (this.containerRef = el) }, h("slot", { key: '24a4edbd446ee53b65b2e683506a163b862dc13a', onSlotchange: this.handleSlotChange })), this.renderCounterBadge()));
    }
    get element() { return getElement(this); }
};
GravityBadgeGroup.style = GravityBadgeGroupStyle0;

export { GravityBadgeGroup as gravity_badge_group };

//# sourceMappingURL=gravity-badge-group.entry.js.map